<template>
    <div class="seller__offices">
        <div class="seller__offices-header">
            <h2 class="seller__offices-title title title--m">Офисы на карте</h2>
            <el-select class="seller__offices-select" v-model="city">
                <el-option value="all" label="Любой город"></el-option>
                <el-option  v-for="item in cities"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id"></el-option>
                <svg slot="prefix">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-compass"></use>
                </svg>
            </el-select>
        </div>
        <offices-map v-if="offices.length"></offices-map>
        <office-info v-if="office.branch_name"></office-info>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {store} from "../../store/office";
import OfficeInfo from "./modules/officeInfo";
import OfficesMap from "./modules/officesMap";

export default {
    name: "Offices",
    components: {OfficesMap, OfficeInfo},
    store,
    data: () => ({
        city: 'all',
    }),
    watch: {
        city: {
            handler: function(val) {
                if (val !== 'all') {
                    this.cityOfficesList(val);
                } else {
                    this.allOfficesList();
                }
            },
        }
    },
    computed: {
        ...mapState([
            'cities',
            'offices',
            'office'
        ]),
    },
    methods: {
        ...mapActions([
            'citiesList',
            'allOfficesList',
            'cityOfficesList'
        ]),
    },
    mounted() {
        this.citiesList();
        this.allOfficesList()
    }
}
</script>
